"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ethers_1 = require("ethers");

var challenge_1 = require("./contract/challenge");

var channel_1 = require("./contract/channel");

var state_1 = require("./contract/state");

function getStateSignerAddress(signedState) {
  var stateHash = state_1.hashState(signedState.state);
  var recoveredAddress = ethers_1.utils.verifyMessage(ethers_1.utils.arrayify(stateHash), signedState.signature);
  var channel = signedState.state.channel;
  var participants = channel.participants;

  if (participants.indexOf(recoveredAddress) < 0) {
    throw new Error("Recovered address " + recoveredAddress + " is not a participant in channel " + channel_1.getChannelId(channel));
  }

  return recoveredAddress;
}

exports.getStateSignerAddress = getStateSignerAddress;

function signState(state, privateKey) {
  var wallet = new ethers_1.Wallet(privateKey);

  if (state.channel.participants.indexOf(wallet.address) < 0) {
    throw new Error("The state must be signed with a participant's private key");
  }

  var hashedState = state_1.hashState(state);
  var signature = signData(hashedState, privateKey);
  return {
    state: state,
    signature: signature
  };
}

exports.signState = signState;

function signChallengeMessage(signedStates, privateKey) {
  if (signedStates.length === 0) {
    throw new Error('At least one signed state must be provided');
  }

  var wallet = new ethers_1.Wallet(privateKey);

  if (signedStates[0].state.channel.participants.indexOf(wallet.address) < 0) {
    throw new Error("The state must be signed with a participant's private key");
  }

  var challengeState = signedStates[signedStates.length - 1].state;
  var challengeHash = challenge_1.hashChallengeMessage(challengeState);
  return signData(challengeHash, privateKey);
}

exports.signChallengeMessage = signChallengeMessage;

function signData(hashedData, privateKey) {
  var signingKey = new ethers_1.utils.SigningKey(privateKey);
  return ethers_1.utils.splitSignature(signingKey.signDigest(ethers_1.utils.hashMessage(ethers_1.utils.arrayify(hashedData))));
}